import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconUmbrellaSecurity: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconUmbrellaSecurity"><Path d="M12 14.5V19.5767C12 20.6389 11.1389 21.5 10.0767 21.5C9.15992 21.5 8.37058 20.8529 8.19078 19.9539L8 19M12 2.5V4.5M12 4.5C7.25923 4.5 3.31649 7.91678 2.5 12.4221H21.5C20.6835 7.91678 16.7408 4.5 12 4.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconUmbrellaSecurity;
